var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12" } },
    [
      !_vm.useFieldValue
        ? _c("app-filter-input", {
            style: { flexGrow: 1 },
            attrs: {
              "field-type": _vm.fieldType,
              label: _vm.label,
              disabled: _vm.inputDisabled,
              decimals: _vm.decimals,
            },
            model: {
              value: _vm.filter.Values[_vm.valueIndex],
              callback: function ($$v) {
                _vm.$set(_vm.filter.Values, _vm.valueIndex, $$v)
              },
              expression: "filter.Values[valueIndex]",
            },
          })
        : _vm.model
        ? _c("app-human-filter-edit-value-default-column", {
            style: { flexGrow: 1 },
            attrs: { label: _vm.label, model: _vm.model },
            model: {
              value: _vm.filter.Values[_vm.valueIndex],
              callback: function ($$v) {
                _vm.$set(_vm.filter.Values, _vm.valueIndex, $$v)
              },
              expression: "filter.Values[valueIndex]",
            },
          })
        : _vm._e(),
      _vm.showUseTodaysDate
        ? _c(
            "div",
            [
              _c("w-checkbox", {
                attrs: {
                  disabled: !_vm.useTodaysDateEnabled,
                  value: _vm.isUseTodaysDateSelected(),
                  label: _vm.$ct("use-todays-date"),
                },
                on: {
                  input: function ($event) {
                    return _vm.setUseTodaysDateSelected($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _vm.model && !_vm.disableUseValueOfOtherField
            ? _c("w-checkbox", {
                attrs: {
                  value: _vm.filter.UseFieldValues[_vm.valueIndex],
                  label: _vm.$ct("use-field"),
                },
                on: {
                  input: function ($event) {
                    return _vm.setUseFieldValue($event)
                  },
                },
              })
            : _vm._e(),
          _vm.valueAmount == -1
            ? _c(
                "w-button",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeValue()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }